import { render, staticRenderFns } from "./A11yDropdown.vue?vue&type=template&id=4fbc939a"
import script from "./A11yDropdown.vue?vue&type=script&lang=js"
export * from "./A11yDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports